import { usePipelineUrlState } from '@/pages/pipelines/common';

import { sanitizeInvestmentPipelineFilters } from '../utils/filters';
import {
  decodeInvestmentPipelineUrlFilters,
  encodeInvestmentPipelineUrlFilters,
  getInvestmentPipelineActiveFilterCount,
  investmentPipelineUrlKeys,
} from '../utils/url';

export const useInvestmentPipelineUrlState = () =>
  usePipelineUrlState({
    decode: decodeInvestmentPipelineUrlFilters,
    encode: encodeInvestmentPipelineUrlFilters,
    sanitize: sanitizeInvestmentPipelineFilters,
    getActiveFilterCount: getInvestmentPipelineActiveFilterCount,
    ownedKeys: investmentPipelineUrlKeys,
  });
